module.exports = __webpack_public_path__ + "static/media/loader.384b5514.svg";